'use client';

import React, { useContext, FC } from 'react';
import { useQueryOrg } from '@services/useQueryOrg';
import { WaitForLoad } from '@components/spinner/Spinner';
import { RootStoreContext } from '@stores/rootStore';
import { observer } from 'mobx-react';
import Loading from './loading';
import { Planting } from '../_components/planting';
import { useSearchParams } from 'next/navigation';
import { PlantingResponse } from '@services/responseTypes';
const Page: FC = observer(() => {
  const {
    uiStore
  } = useContext(RootStoreContext);
  const searchParams = useSearchParams();
  const {
    data,
    isLoading
  } = useQueryOrg<PlantingResponse | undefined>({
    queryKey: ['overview', 'planting stats', searchParams?.get('filter[season_id]'), searchParams?.get('filter[year]'), searchParams?.get('filter[crop]'), searchParams?.get('filter[label_ids][]'), searchParams?.get('filter[country]'), searchParams?.get('filter[province]'), searchParams?.get('filter[village]'), searchParams?.get('filter[subdistrict]'), searchParams?.get('filter[district]')],
    queryFn: () => uiStore.currentOrganization?.fetchPlantingStats({
      ...(searchParams?.has('filter[season_id]') && {
        season: searchParams.get('filter[season_id]') || undefined
      }),
      ...(searchParams?.has('filter[year]') && {
        year: parseInt(searchParams.get('filter[year]')!, 10)
      }),
      ...(searchParams?.has('filter[crop]') && {
        crop: searchParams.get('filter[crop]') || undefined
      }),
      ...(searchParams?.has('filter[label_ids][]') && {
        labels: searchParams.get('filter[label_ids][]') || undefined
      }),
      ...(searchParams?.has('filter[country]') && {
        country: searchParams.get('filter[country]') || undefined
      }),
      ...(searchParams?.has('filter[province]') && {
        region: searchParams.get('filter[province]') || undefined
      }),
      ...(searchParams?.has('filter[village]') && {
        village: searchParams.get('filter[village]') || undefined
      }),
      ...(searchParams?.has('filter[subdistrict]') && {
        subdistrict: searchParams.get('filter[subdistrict]') || undefined
      }),
      ...(searchParams?.has('filter[district]') && {
        district: searchParams.get('filter[district]') || undefined
      })
    }),
    enabled: searchParams?.has('filter[year]') || searchParams?.has('filter[season_id]'),
    refetchOnWindowFocus: false
  });
  return <WaitForLoad isLoading={isLoading} customSpinner={<Loading />}>
      {() => <Planting stats={data} />}
    </WaitForLoad>;
});
export default Page;